import React from 'react';
import { BudgetCategory, Condition, BudgetLineItem as BudgetLineItemType } from '../types/budget';
import { BudgetLineItem } from './BudgetLineItem';
import { InlineConditions } from './InlineConditions';
interface CategoryDetailProps {
  category: BudgetCategory;
  conditions: Condition[];
  onAddCondition: (item: BudgetLineItemType) => void;
  onEditCondition: (c: Condition) => void;
}
export function CategoryDetail({
  category,
  conditions,
  onAddCondition,
  onEditCondition
}: CategoryDetailProps) {
  const formatCurrency = (val: number) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(val);
  const formatPercent = (val: number) => new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 1
  }).format(val / 100);
  const cleanName = category.name.replace(/^TOTAL\s+/i, '');
  return <div className="flex-1 overflow-y-auto bg-gray-50/50 p-8 lg:p-12" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        {/* Category Header */}
        <div className="mb-8" data-id="element-16">
          <h2 className="text-3xl font-heading font-light text-primary mb-4" data-id="element-17">
            {cleanName}
          </h2>
          <div className="flex items-center gap-8 text-sm font-body font-normal text-gray-500 bg-white p-4 rounded-xl border border-gray-200 shadow-sm inline-flex" data-id="element-18">
            <div className="flex flex-col" data-id="element-19">
              <span className="text-xs uppercase tracking-wider text-gray-400 mb-1" data-id="element-20">
                Total Budget
              </span>
              <span className="text-2xl font-medium text-primary" data-id="element-21">
                {formatCurrency(category.totalBudget)}
              </span>
            </div>
            <div className="w-px h-10 bg-gray-200" data-id="element-22"></div>
            <div className="flex flex-col" data-id="element-23">
              <span className="text-xs uppercase tracking-wider text-gray-400 mb-1" data-id="element-24">
                % of Total
              </span>
              <span className="text-2xl font-medium text-primary" data-id="element-25">
                {formatPercent(category.totalPercent)}
              </span>
            </div>
          </div>
        </div>

        {/* Line Items Table */}
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden mb-8" data-id="element-26">
          <div className="flex items-center py-4 px-6 bg-gray-50 border-b border-gray-200 text-xs font-body font-medium text-gray-500 uppercase tracking-wider" data-id="element-27">
            <div className="flex-1" data-id="element-28">Line Item</div>
            <div className="w-24 text-right" data-id="element-29">% of Budget</div>
            <div className="w-32 text-right" data-id="element-30">Cost/SqFt</div>
            <div className="w-36 text-right" data-id="element-31">Budget</div>
          </div>

          <div className="flex flex-col" data-id="element-32">
            {category.lineItems.map(item => <BudgetLineItem key={item.id} item={item} condition={conditions.find(c => c.lineItemId === item.id)} onAddCondition={() => onAddCondition(item)} onEditCondition={() => {
            const cond = conditions.find(c => c.lineItemId === item.id);
            if (cond) onEditCondition(cond);
          }} data-id="element-33" />)}
          </div>
        </div>

        {/* Inline Conditions */}
        <InlineConditions conditions={conditions} onEditCondition={onEditCondition} data-id="element-34" />
      </div>
    </div>;
}